import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

const RepeatTrendChart = ({ data, onDrilldown }) => {
    if (!data || data.length === 0) return (
        <div className="flex flex-col items-center justify-center h-full text-slate-300 py-20 gap-2">
            <span className="text-4xl opacity-30">📊</span>
            <p className="text-[10px] font-black uppercase tracking-widest">No repeat ticket data</p>
        </div>
    );

    const categories = data.map(d => d.month);
    const companyReopens = data.map(d => parseInt(d.company_reopens, 10) || 0);

    const options = {
        chart: {
            type: 'column',
            style: { fontFamily: 'inherit' }
        },
        title: { text: null },
        subtitle: { text: null },
        xAxis: {
            categories,
            crosshair: true,
            labels: { style: { fontSize: '11px', fontWeight: '700', color: '#64748b' } }
        },
        yAxis: {
            title: { text: 'Tickets Reopened', style: { fontSize: '10px', color: '#94a3b8' } },
            min: 0,
            gridLineColor: '#f1f5f9'
        },
        tooltip: {
            headerFormat: '<span style="font-size:11px;font-weight:800">{point.key}</span><table>',
            pointFormat: '<tr><td style="color:{series.color};padding:4px 0">{series.name}: </td><td style="padding:4px 0"><b>{point.y}</b></td></tr>',
            footerFormat: '</table>',
            shared: true,
            useHTML: true,
            backgroundColor: '#ffffff',
            borderWidth: 1,
            borderColor: '#e2e8f0',
            shadow: true,
            style: { fontSize: '11px', color: '#334155' }
        },
        plotOptions: {
            column: {
                pointPadding: 0.15,
                borderWidth: 0,
                borderRadius: 6,
                cursor: 'pointer',
                point: {
                    events: {
                        click: function () {
                            const monthData = data[this.index];
                            if (!monthData || !onDrilldown) return;
                            onDrilldown(
                                monthData.month,
                                `Repeat Tickets — ${monthData.month} (${monthData.company_reopens})`,
                                'repeat'
                            );
                        }
                    }
                }
            }
        },
        series: [{
            name: 'Reopened Tickets',
            data: companyReopens,
            color: '#dc2626',
        }],
        credits: { enabled: false },
        legend: { enabled: false }
    };

    return <HighchartsReact highcharts={Highcharts} options={options} />;
};

export default RepeatTrendChart;
